import { render, staticRenderFns } from "./HotNews.vue?vue&type=template&id=eb6faf28&scoped=true&"
import script from "./HotNews.vue?vue&type=script&lang=js&"
export * from "./HotNews.vue?vue&type=script&lang=js&"
import style0 from "./HotNews.vue?vue&type=style&index=0&id=eb6faf28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6faf28",
  null
  
)

export default component.exports